/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from 'react';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { useSearchParams } from 'react-router-dom';
import { DatePicker, Space } from 'antd';
import { Tooltip } from 'react-tooltip';
import FilterCheckbox from './FilterCheckbox';
import CustomMonthYearPicker from '../../../components/CustomMonthYearPicker';
import YearPicker from '../../../components/CustomMonthYearPicker/YearPicker';
const { RangePicker } = DatePicker;

const SettlementsFilter = ({ 
    setSelectedYear,
    setSelectedMonth,
    selectedMonth,
    selectedYear,
    onMonthClick,
    onYearClick,
    FilterData,
    setFilterCheckBox,
    handleApplyFilter,
    isFilterOpen,
    setIsFilterOpen,
    handleOnClickSearch,
    DateRange,
    DateRangeError,
    SetDateRangeError,
    handleClearFilter, }) => {

    const ref = useRef();

    const [active, setActive] = useState('monthly')

    useOnClickOutside(ref, () => {
        setIsFilterOpen(false)
    })

    const handleClickYearly = () => {
        setSelectedMonth('');
        setActive('yearly')
    }

    const handleClickMonthly = () => {
        setSelectedYear(new Date().getFullYear());
        setActive('monthly')
    }
    
    useEffect(() => {
        
    }, [])

    return (
        <div className="relative">
            <img
                src="/assets/images/filter.svg"
                className="cursor-pointer p-3 hover:bg-[#ECD2E0] rounded-full"
                alt=""
                data-testid="filter-btn"
                data-tooltip-id="my-tooltip-14"
                onClick={() => setIsFilterOpen(!isFilterOpen)}
            />
            <Tooltip
                id="my-tooltip-14"
                place="bottom"
                content="Filter"
            />
            {isFilterOpen && <>
                <div ref={ref} className="p-4 absolute top-[40px] right-0 rounded-[4px] flex space-x-3 z-10 bg-white border border-[#F7D7E8] min-h-[325px] min-w-[489px]">
                    <div className={`flex flex-col justify-between pb-[2px]`}>
                        <div className="flex flex-col">
                            <h1 
                                data-testid="monthly-option"
                                className={`font-[400] text-base mb-1 cursor-pointer ${active === 'monthly' ? 'text-primary' : 'text-[#1F1F1F]'}`}
                                onClick={handleClickMonthly}
                            >
                                Monthly
                            </h1>
                            <h1 
                                data-testid="yearly-option"
                                className={`font-[400] text-base mb-1 cursor-pointer ${active === 'yearly' ? 'text-primary' : 'text-[#1F1F1F]'}`}
                                onClick={handleClickYearly}
                            >
                                Yearly
                            </h1>
                        </div>
                        <div className='mt-3'>
                            <button className='bg-primary px-[47.5px] py-[5px] w-[129px] text-[14px] leading-[22px] font-[400] rounded-[12px] text-[#FFFFFF]' data-testid="apply-btn" onClick={() => {
                                handleApplyFilter(false, selectedYear, selectedMonth);
                                setActive('monthly')
                                setIsFilterOpen(false)
                            }}>
                                Apply
                            </button>
                            <button data-testid="clear-btn" className="text-[14px] font-[400] leading-[22px] text-[#731748] whitespace-nowrap mt-3 w-full" onClick={() => {
                                setSelectedYear(new Date().getFullYear());
                                setSelectedMonth('');
                                handleApplyFilter(true);
                                setActive('monthly')
                                setIsFilterOpen(false)
                            }}>
                                Clear All
                            </button>
                        </div>
                    </div>
                    <div className='w-full border-l pl-[20px] border-[#EB9DC7]'>
                        <div className='relative z-0'>
                            <p className='pb-3 font-[400] text-base text-[#000000B1]'>{`${active === 'monthly' ? 'Monthly' : 'Yearly'}`}</p>
                            <div className='relative'>
                                {active === 'monthly' ? <CustomMonthYearPicker
                                    start='create_start'
                                    end='create_end'
                                    DateRangeError={DateRangeError}
                                    DateRange={DateRange} 
                                    onYearClick={onYearClick}
                                    onMonthClick={onMonthClick}
                                    selectedYear={selectedYear}
                                    selectedMonth={selectedMonth}
                                /> : <YearPicker onYearClick={onYearClick} selectedYear={selectedYear} />}
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default SettlementsFilter;
